import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';

import { changeFormFieldValue } from 'apps/auth/actions/formAction';
import { Badge } from 'apps/auth/components/common/Badge/Badge';
import { Button } from 'apps/auth/components/common/Button/Button';
import { CommonPage } from 'apps/auth/components/common/Layout/CommonPage/CommonPage';
import { FixedBottomPanel } from 'apps/auth/components/common/Layout/FixedBottomPanel/FixedBottomPanel';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import { Row } from 'apps/auth/components/common/Layout/Row';
import { Panel } from 'apps/auth/components/common/Panel/Panel';
import { PanelContent, PanelFrame, PanelRightBlock } from 'apps/auth/components/common/Panel/styles';
import PopupNew from 'apps/auth/components/common/Popup/PopupNew';
import { Text } from 'apps/auth/components/common/Text/Text';
import PaysendPlusPlanChangePopup from 'apps/auth/components/paysendPlus/subscription/PaysendPlusPlanChangePopup';
import BasePage from 'apps/auth/components/utils/BasePage';
import { PLUS_CHANGE_PLAN_FORM_NAME } from 'apps/auth/constants/formName';
import { AUTH_PLUS_MAIN_PAGE, AUTH_PLUS_PLAN_UPDATE_ACTION } from 'apps/auth/constants/UrlConstants';
import { toLowerCase } from 'apps/auth/helpers/utils';
import { useExtra, useForm, usePageMessages } from 'apps/auth/hooks/selectors';

const PaysendPlusChangePlanPage = (props) => {
    const [disabled, setDisabled] = useState(true);

    const popupRef = useRef(null);
    const submitRef = useRef(null);
    const { subscriptionTariffs, subscriptionTariffsUI } = useExtra();
    const { planSelectSubTitle, planSelectTitle, continueButton } = usePageMessages();
    const { fields } = useForm(PLUS_CHANGE_PLAN_FORM_NAME);

    useEffect(() => {
        setDisabled(fields?.planId?.value === '' || fields?.planId?.value === null);
    }, [fields]);

    const selectPlan = (e, tariff) => {
        props.changeFormFieldValue(PLUS_CHANGE_PLAN_FORM_NAME, tariff?.id, 'planId');
    };

    const openPrecheck = () => {
        popupRef?.current.open(
            <PaysendPlusPlanChangePopup popupRef={popupRef} action={AUTH_PLUS_PLAN_UPDATE_ACTION} tariff={getSelectedTariff()} submitRef={submitRef} />,
        );
    };

    const getSelectedTariff = () => {
        return subscriptionTariffs.find((t) => t.id === fields?.planId?.value);
    };

    return (
        <>
            <CommonPage backUrl={AUTH_PLUS_MAIN_PAGE} leftCloseIcon>
                <>
                    <HeaderPanel title={planSelectTitle} subtitle={planSelectSubTitle} />
                    {subscriptionTariffsUI.map((tariff) => (
                        <Row indent="adaptive-24-32" key={tariff.id} relative>
                            <Panel
                                isBordered
                                hasBorderRadius
                                isSelectedBordered={tariff.id === fields?.planId?.value}
                                isHoverable
                                badgeCaption={tariff.promoLabel}
                                onClick={(e) => selectPlan(e, tariff)}
                            >
                                <PanelFrame>
                                    <PanelContent>
                                        <Text variant="div" indent="4px">
                                            {tariff.title}
                                        </Text>
                                        <Text variant="div" size="secondary" color="secondary">
                                            {tariff.description}
                                        </Text>
                                    </PanelContent>
                                    <PanelRightBlock>
                                        <Badge
                                            variant={tariff.promoLabel !== '' ? 'primary' : 'secondary'}
                                            size="price"
                                            caption={tariff.amount}
                                            currencyValue={toLowerCase(tariff.currencyCode)}
                                        />
                                    </PanelRightBlock>
                                </PanelFrame>
                            </Panel>
                        </Row>
                    ))}
                    <FixedBottomPanel isRightAligned>
                        <Button type="button" raised={true} caption={continueButton} onClick={openPrecheck} ref={submitRef} disabled={disabled} />
                    </FixedBottomPanel>
                </>
            </CommonPage>
            <PopupNew ref={popupRef} />
        </>
    );
};

export default connect(null, { changeFormFieldValue })(BasePage(PaysendPlusChangePlanPage));
